/**
 * Mirrors MadCloud.Domain.Status.StatusIncidentStatus. The values from Scheduled onwards describe the
 * lifecycle of planned maintenance; the earlier ones describe an unplanned incident.
 */
export enum StatusIncidentStatus {
  Investigating = 0,
  Identified = 1,
  Monitoring = 2,
  Resolved = 3,
  Postmortem = 4,
  Scheduled = 10,
  InProgress = 11,
  Verifying = 12,
  Completed = 13
}